import * as React from 'react';
import { Placeholder as UIPlaceholder } from 'semantic-ui-react';
export var Placeholder = function (_a) {
    var line = _a.line;
    return (<UIPlaceholder>{Array(line !== null && line !== void 0 ? line : 5).fill(<UIPlaceholder.Line />)}</UIPlaceholder>);
};
